'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = render;


function render(blocks, renderEmoticons) {
    var emojiLocation = _state2.default.setting('emojiLocation');
    var showEmoticons = typeof renderEmoticons === 'undefined' ? _state2.default.setting('buffers.show_emoticons') : !!renderEmoticons;

    var retHtml = blocks.reduce(function (html, block, i) {
        var style = '';
        var classes = '';

        (0, _keys2.default)(block.styles).forEach(function (s) {
            if (s === 'underline') {
                style += 'text-decoration:underline;';
            } else if (s === 'bold') {
                style += 'font-weight:bold;';
            } else if (s === 'italic') {
                style += 'font-style:italic;';
            } else if (s === 'quote') {
                classes += 'kiwi-formatting-extras-quote ';
            } else if (s === 'block') {
                classes += 'kiwi-formatting-extras-block ';
            } else if (s === 'color') {
                classes += 'irc-fg-colour-' + block.styles[s] + ' ';
            } else if (s === 'background') {
                classes += 'irc-bg-colour-' + block.styles[s] + ' ';
            }
        });

        var content = void 0;
        switch (block.type) {
            case 'url':
                content = linkifyUrl(block, {
                    addHandle: true,
                    handleClass: 'fa fa-share-square u-link kiwi-messagelist-message-linkhandle'
                });
                break;
            case 'user':
                content = linkifyUser(block);
                break;
            case 'channel':
                content = linkifyChannel(block);
                break;
            case 'emoji':
                content = addEmoji(block, blocks.length === 1, emojiLocation, showEmoticons);
                break;
            default:
                content = (0, _lodash.escape)(block.content);
        }

        return html + buildSpan(content, classes, style);
    }, '');

    return '' + retHtml;
}

function linkifyUrl(block, _opts) {
    var opts = _opts || {};
    var nice = '';

    if (block.content.length > 100) {
        nice = (0, _lodash.escape)(block.content.substr(0, 100)) + '...';
    } else {
        nice = (0, _lodash.escape)(block.content);
    }

    var href = block.meta.url.replace(/"/g, '%22');
    var out = '<a target="_blank" href="' + href + '" rel="noopener noreferrer">' + nice + '</a>';

    if (opts.addHandle) {
        var cssClass = opts.handleClass || '';
        var content = opts.handleContent || '';
        out += '<a data-url="' + (0, _lodash.escape)(block.meta.url) + '" class="' + cssClass + '">' + content + '</a>';
    }

    return out;
}

function linkifyUser(block) {
    var escaped = (0, _lodash.escape)(block.meta.user);
    var colour = block.meta.colour;

    return '<a class="kiwi-nick" data-nick="' + escaped + '"' + (colour ? ' style="color:' + colour + '"' : '') + ('>' + escaped + '</a>');
}

function linkifyChannel(block) {
    return '<a class="u-link kiwi-channel" data-channel-name="' + (0, _lodash.escape)(block.meta.channel) + '">' + (0, _lodash.escape)(block.content) + '</a>';
}

function addEmoji(block, isSingle, emojiLocation, showEmoticons) {
    if (!showEmoticons) {
        return block.content;
    }
    var emoji = block.meta.emoji;
    var classes = 'kiwi-messagelist-emoji' + (isSingle ? ' kiwi-messagelist-emoji--single' : '');
    var src = '' + emojiLocation + emoji + '.png';

    return '<img class="' + classes + '" src="' + src + '" alt="' + (0, _lodash.escape)(block.content) + '" title="' + (0, _lodash.escape)(block.content) + '" />';
}

function buildSpan(content, classes, style) {
    if (style === '' && classes === '') {
        return content;
    }

    return '<span' + (style !== '' ? ' style="' + style + '"' : '') + (classes !== '' ? ' class="' + classes + '"' : '') + ('>' + content + '</span>');
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/renderers/Html.js
// module id = Nbm2
// module chunks = 1